import React from 'react'
import styled from '@emotion/styled'
import {GuestType} from '@findhotel/sapi'

import {Divider} from '@vio/atlas/src/components/designSystem/Divider'
import {cssTheme} from '@vio/atlas/src/themes'
import {linariaMq} from '@vio/atlas/src/utils/breakpoints'
import {Entity} from '@vio/core/src/analytics/types/Events'

import {GuestTypesSubSection} from './GuestTypesSubSection'
import {ReviewsTrackClick, SelectedElementType} from './ReviewsTrackClick'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${cssTheme.layout.spacing.s700};
  grid-area: summary;
  margin-top: ${cssTheme.layout.spacing.s500};

  .--guest-types-sub-section-icons-scroll,
  .--guest-types-sub-section-title {
    padding-left: ${cssTheme.layout.spacing.s500};
    padding-right: ${cssTheme.layout.spacing.s500};
  }

  ${linariaMq.desktopMd} {
    padding: 0;
    .--guest-types-sub-section-icons-scroll,
    .--guest-types-sub-section-title {
      padding-left: 0;
      padding-right: 0;
    }
  }
`

interface Props {
  hasDivider: boolean
  guestType: GuestType
}
export const ReviewSectionSummary: React.FC<Props> = ({
  hasDivider,
  guestType
}) => {
  return (
    <Wrapper>
      <ReviewsTrackClick
        dataId="guestTypes-subsection"
        element={SelectedElementType.GuestType}
        entity={Entity.HotelDetailsReviewsSection}
      >
        <GuestTypesSubSection guestType={guestType} />
      </ReviewsTrackClick>
      {hasDivider && <Divider />}
    </Wrapper>
  )
}
